import {
  type Cart,
  cartApi,
  updateCart,
  CartEvents,
  CartEventsEnum,
  getActiveCart,
  getUniquePromotions,
  getFiredPromotionFromEntries,
} from '@commerce-cart-webcomponents/sdk';
import { Coupons } from '@commerce-promotion-webcomponents/ui';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@nextgen-web-framework/core';
import { type EligibleCoupon, type InvalidCouponsResponse } from '@commerce-promotion-webcomponents/sdk';
import { useFeatureFlag } from '../../../common';
import { CartCouponsWrapperProps } from './types/propTypes';
const CartCouponsWrapper = ({ cart, subCart }: CartCouponsWrapperProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { showAuxiliaryToggleFlag } = useFeatureFlag();

  function applyCoupons(coupons: string[]) {
    return cartApi
      .applyCoupon({
        cartId: cart.id,
        subCartId: subCart?.subCartId as string,
        payload: {
          coupons,
          version: cart.version,
        },
      })
      .then((cart) => {
        dispatch(updateCart(cart as Cart));
        CartEvents.publishEvent({
          event: CartEventsEnum.UpdateCartEntryQty,
          payload: {
            cart,
            cartId: (cart as Cart).id,
          },
          sync: true,
        });
        // We need to find currently open subCart.
        const activeCart = getActiveCart(cart as Cart, subCart?.subCartId as string);
        return (activeCart?.couponResults?.invalidCoupons as InvalidCouponsResponse[]) ?? undefined;
      });
  }

  const getAllFiredPromotion = () => {
    const { promotionResults, entries } = getActiveCart(cart as Cart, subCart?.subCartId as string);
    return getUniquePromotions(
      [...(promotionResults?.firedPromotions ?? []), ...getFiredPromotionFromEntries(entries)],
      showAuxiliaryToggleFlag,
    );
  };

  return (
    <Coupons
      firedPromotions={getAllFiredPromotion()}
      applyCoupon={applyCoupons}
      applicableCoupons={subCart?.couponResults?.applicableCoupons as EligibleCoupon[]}
      appliedCoupons={subCart?.couponResults?.appliedCoupons}
      potentialCoupons={subCart?.couponResults?.potentialCoupons as EligibleCoupon[]}
    />
  );
};

export { CartCouponsWrapper };
